/**
* @param {Element} element target element
* @param {Number} threshold distance threshold in pixels
*/
export function transformHeaderOnScroll(target, threshold) {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop >= threshold) {
        target.classList.add("scrolledHeader");
    } else {
        target.classList.remove("scrolledHeader");
    }
}

/**
* @param {Element} target target element
* @param {Element} trigger trigger element
*/
export function toggleMobileMenu(target, trigger) {
    target.classList.toggle('activeMenu');
    trigger.classList.toggle('isActive');
    trigger.setAttribute('aria-expanded', trigger.classList.contains('isActive') ? 'true' : 'false');
}